(function(Way2web) {
    'use strict';

    Way2web.onDomReady = function() {
        Way2web.loadEvents();
        Way2web.eventDetail();
        Way2web.eventCards();
        Way2web.memberCards();
        Way2web.video();
        Way2web.mailchimp();
        Way2web.Modal.gallery();
        Way2web.PaymentForm.autoFill();

        $( ".js-no-submit" ).on('submit', function( event ) {
            event.preventDefault();
        });
    };

    Way2web.mailchimp = function() {

        var $mailchimp = $(".js-form-mailchimp");

        $mailchimp.on("submit", function ( event ) {

            var $required = $('.js-required');

            var validEmail = Helper.validateEmail($required.val());

            if ( $required.prop('required') && ( $required.val().length === 0 || !validEmail) ) {
                event.preventDefault();
                $required.focus();
                return false;
            }

        });
    };

    Way2web.video = function() {

        $( ".js-video-play" ).on('click', function( event ) {
            event.preventDefault();
            var $that       = $(this);
            var $video      = $(this).parents('.js-video');
            var $iframe     = $video.find('iframe');
            var $src        = $iframe.attr('src');

            $iframe.attr('src', $src + '&autoplay=1');
            $(this).find('.video__control').fadeOut(function () {
                $that.remove();
            });

        });

    };

    Way2web.eventCards = function() {
        var listSelector        = 'js-list-participant-filter';
        var $listChilds         = $('.js-list li');

        var $searchInput        = $( ".js-list-participant-search" );

        var searchSelectors     = [ 'js-searchable-name', 'js-searchable-context' ];

        if ( $listChilds.length > 0 ) {

            $searchInput.on( "input", function() {
               cardList.search( $(this).val() );
            });

            var cardList = new List( listSelector , {
                valueNames: searchSelectors,
                listClass: 'js-list',
                page: 12,
                plugins: [ ListPagination({
                    outerWindow: 1,
                    innerWindow: 1
                }) ]
            });

            cardList.on('updated', function(list) {
                if (list.matchingItems.length === 0) {
                    $('.js-list-empty').removeClass('hide');
                } else {
                    $('.js-list-empty').addClass('hide');
                }
            });

        }
    };

    Way2web.memberCards = function() {

        var listSelector        = 'js-list-filter';
        var $searchInput        = $( ".js-listjs-search" );

        var searchSelectors     = ['js-filter-name', 'js-filter-function', 'js-filter-division', 'js-filter-email'];


        $searchInput.on( "input", function() {
           cardList.search( $(this).val() );
        });

        var cardList = new List( listSelector , {
            valueNames: searchSelectors,
            listClass: 'js-list',
            page: 12,
            plugins: [ ListPagination({
                outerWindow: 1,
                innerWindow: 1
            }) ]
        });

        cardList.on('updated', function(list) {
            if (list.matchingItems.length === 0) {
                $('.js-list-empty').removeClass('hide');
            } else {
                $('.js-list-empty').addClass('hide');
            }
        });

    };

    Way2web.loadEvents = function() {
        var $btnLoadMore = $(".btn.load-more-events");

        $btnLoadMore.on('click', function(e) {
            e.preventDefault();

            var posts = $('.section.gradient .evenementen-list .event').length;

            $.ajax({
                type: "POST",
                url: w2w_leden_ajax.ajax_url,
                dataType: 'html',
                data: ({ action: 'w2w_load_more_events', posts: posts}),
                success: function(data){
                    if(data == "false") {
                        $btnLoadMore.text('Er zijn geen oudere evenementen meer!').off('click').attr('disabled', 'disabled').removeClass('btn-invert').addClass('btn-primary');
                    }
                    else {
                        $('.past').append(data);
                    }

                }
            });

        });
    };

    Way2web.eventDetail = function() {

        var $eventForm              = $('.js-event-form');
        var $eventModal             = $('.js-event-modal');
        var $eventModalForm         = $('.js-event-modal-form');
        var $eventIntroduceeCheck   = $('.js-introducee-check');
        var $eventModalMessages     = $eventModal.find('.js-modal-messages');
        var $eventModalContent      = $eventModal.find('.js-modal-content');

        $('.js-input-mirror').on('input', function() {
            var $input      = $(this);
            var $mirrored   = $( $input.data('input-mirrored') );

            $mirrored.text( $input.val() );

            $eventModal.trigger( "entryFixPrice" );
            $eventModal.trigger( "setIntroduceeCheck", [true] );
        });

        $eventModal.on( "entryFixPrice", function() {

            var $entry          = $(this);
            var $introducee     = $entry.find('.js-event-introducee');
            var $price          = $entry.find('.js-event-price');
            var $total_price    = $entry.find('.js-event-total-price');

            var eventPrice      = $('ul.list li.js-calc-costs').data('kosten');
            // if event price is not set
            if(isNaN(eventPrice) || eventPrice == '0') {
                eventPrice = '-';
            }

            if ($introducee.text().length > 0) {
                $introducee.removeClass('hide');
                $introducee.next().removeClass('hide');

                $price.text(eventPrice);
                if(eventPrice == '-') {
                    $total_price.text(eventPrice);
                }
                else {
                    $total_price.text(eventPrice * 2);
                }
            } else {
                $introducee.addClass('hide');
                $introducee.next().addClass('hide');

                $price.text(eventPrice);
                $total_price.text(eventPrice);
            }

        });

        $eventModal.on( "setIntroduceeCheck", function(event, force) {
            if (force) {
                $eventIntroduceeCheck.prop('checked', true);
            }

            var $target = $( $eventIntroduceeCheck.data('target') );
            if( $eventIntroduceeCheck.prop('checked') ) {
                $target.prop('required', true);
            } else {
                $target.prop('required', false);
            }
        });

        $eventIntroduceeCheck.on( "change", function() {
            $eventModal.trigger( "setIntroduceeCheck");
        });

        $eventForm.find( ".js-introducee-validate" ).on( "click", function(e) {

            e.preventDefault();

            var $target = $('.js-introducee-validate');
            var $required = $('.js-make-required');

            if ( $required.prop('required') && $required.val().length === 0) {
                $eventForm.find('.js-make-required').focus();
                return false;
            }

            $('#confirm').modal();
        });

        $eventModalForm.on('submit', function(e) {
            e.preventDefault();
            var form = $(this);

            jQuery.ajax({
                url: w2w_leden_ajax.ajax_url,
                type: 'POST',
                dataType: 'json',
                data: {
                    action : 'w2w_deelname',
                    subaction: $eventForm.find('input[name=subaction]').val(),
                    event_id: $eventForm.find('input[name=event_id]').val(),
                    introduce_check: $eventForm.find('input[id=meta-check]:checked').val(),
                    introduce_naam: $eventForm.find('input[name=introduce_naam]').val()
                },
                success: function(result) {
                    if(result.error) {
                        $eventModalForm.find('.success').html('').addClass('hide');
                        $eventModalForm.find('.error').html(result.error).removeClass('hide');
                    }
                    else {

                        $eventModalMessages.find('.error').html('').addClass('hide');
                        $eventModalMessages.find('.success').html(result.success).removeClass('hide');

                        $eventModalContent.children().css('visibility', 'hidden');
                        $eventModalForm.find('button[type=submit]').attr('disabled', 'disabled');
                    }
                }
            });

            return false;
        });

        /* set price and introduce on load */
        $('.js-input-mirror').trigger( 'input' );
        $eventModal.trigger( "entryFixPrice" );
    };

})(window.Way2web = window.Way2web || {});

$(document).ready(Way2web.onDomReady);
